import styled from "@emotion/styled";

export const InlineEditWrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  word-break: break-word;

  label {
    line-height: 0;
  }
  label + .MuiInput-formControl {
    margin: 0;
  }

  input {
    margin: 1rem 0 0;
  }
`;
